import Icon from "components/general/Icon";
import React from "react";
import iconArrowForward from "images/ic_arrow_forward_2.png";
// import sortBy from "lodash/sortBy";
import styled from "styled-components";
import theme from "styles/theme";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing.unit * 1}px;
  padding: ${theme.spacing.unit * 2}px ${theme.spacing.unit * 1}px;

  color: ${(props) => props.color};
  background-color: ${(props) => props.$backgroundColor};
  border-radius: 16px;

  border: 1px solid ${(props) => props.$borderColor};
`;

const Header = styled.div`
  padding: ${theme.spacing.unit * 1}px;

  font-size: 14px;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  color: ${(props) => props.color};
`;

const ContentPageLink = styled.div`
  padding: ${theme.spacing.unit * 2}px ${theme.spacing.unit * 1}px;
  display: flex;
  column-gap: ${theme.spacing.unit * 1}px;
  align-items: center;
  border-radius: 16px;

  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.$hoverBackgroundColor};
  }
`;

const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing.unit * 1}px;
`;

const Title = styled.div`
  font-size: 14px;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
`;

const Description = styled.h3`
  font-size: 14px;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`;

const JobPageContentPageLinks = (props) => {
  const { className, header, contentPageLinks, brandingData } = props;

  console.log(header);

  return (
    <div className={className}>
      <Container
        color={brandingData.primaryTextColor}
        $backgroundColor={theme.colors.white}
        $borderColor={brandingData.secondaryStep3Color}
      >
        {header && (
          <Header color={brandingData.primaryTextColor}>{header}</Header>
        )}
        {contentPageLinks.map((contentPageLink, i) => {
          return (
            <ContentPageLink
              key={i}
              as="a"
              href={contentPageLink.contentPage.publicUrl}
              $hoverBackgroundColor={brandingData.secondaryStep1Color}
            >
              <InfoContainer>
                <Title>{contentPageLink.contentPage.linkTitle}</Title>
                {contentPageLink.contentPage.linkDescription && (
                  <Description>
                    {contentPageLink.contentPage.linkDescription}
                  </Description>
                )}
              </InfoContainer>
              <Icon
                src={iconArrowForward}
                iconColor={brandingData.primaryTextColor}
              />
            </ContentPageLink>
          );
        })}
      </Container>
    </div>
  );
};

export default JobPageContentPageLinks;
